<h2 class="sectionTitle">{{'FRONT_USER.WORKSPACE.ETENDER_MESSAGES'| translate}}</h2>
<app-grid-view #ETenderMessages></app-grid-view>